<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="剧本id" prop="scriptId" >
        <a-input v-model="form.scriptId" placeholder="请输入剧本id" />
      </a-form-model-item>
      <a-form-model-item label="主持DM" prop="dmId" >
        <a-input v-model="form.dmId" placeholder="请输入主持DM" />
      </a-form-model-item>
      <a-form-model-item label="房间名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入房间名称" />
      </a-form-model-item>
      <a-form-model-item label="秘钥名" prop="keyName" >
        <a-input v-model="form.keyName" placeholder="请输入秘钥名" />
      </a-form-model-item>
      <a-form-model-item label="秘钥数字" prop="keyValue" >
        <a-input v-model="form.keyValue" placeholder="请输入秘钥数字" />
      </a-form-model-item>
      <a-form-model-item label="最大人数" prop="maxPlayers" >
        <a-input v-model="form.maxPlayers" placeholder="请输入最大人数" />
      </a-form-model-item>
      <a-form-model-item label="当前人数" prop="currentPlayers" >
        <a-input v-model="form.currentPlayers" placeholder="请输入当前人数" />
      </a-form-model-item>
      <a-form-model-item label="房间配置" prop="settings" >
      </a-form-model-item>
      <a-form-model-item label="状态 1.等待中 2.游戏中 3.已结束" prop="status" >
      </a-form-model-item>
      <a-form-model-item label="逻辑删除标记，1：删除，0：未删除，默认0" prop="isDeleted" v-if="formType === 1">
        <a-input v-model="form.isDeleted" placeholder="请输入逻辑删除标记，1：删除，0：未删除，默认0" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="版本号" prop="version" v-if="formType === 1">
        <a-input v-model="form.version" placeholder="请输入版本号" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGameRoom, addGameRoom, updateGameRoom } from '@/api/played/gameRoom'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        scriptId: null,
        dmId: null,
        name: null,
        keyName: null,
        keyValue: null,
        maxPlayers: null,
        currentPlayers: null,
        settings: null,
        status: 0,
        creator: null,
        modifier: null,
        createTime: null,
        updateTime: null,
        isDeleted: null,
        remark: null,
        version: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        scriptId: [
          { required: true, message: '剧本id不能为空', trigger: 'blur' }
        ],
        dmId: [
          { required: true, message: '主持DM不能为空', trigger: 'blur' }
        ],
        keyName: [
          { required: true, message: '秘钥名不能为空', trigger: 'blur' }
        ],
        keyValue: [
          { required: true, message: '秘钥数字不能为空', trigger: 'blur' }
        ],
        maxPlayers: [
          { required: true, message: '最大人数不能为空', trigger: 'blur' }
        ],
        currentPlayers: [
          { required: true, message: '当前人数不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 1.等待中 2.游戏中 3.已结束不能为空', trigger: 'blur' }
        ],
        isDeleted: [
          { required: true, message: '逻辑删除标记，1：删除，0：未删除，默认0不能为空', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '版本号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        scriptId: null,
        dmId: null,
        name: null,
        keyName: null,
        keyValue: null,
        maxPlayers: null,
        currentPlayers: null,
        settings: null,
        status: 0,
        creator: null,
        modifier: null,
        createTime: null,
        updateTime: null,
        isDeleted: null,
        remark: null,
        version: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGameRoom(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateGameRoom(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addGameRoom(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
